module.exports = __webpack_public_path__ + "img/label-help.317c90ab.svg";